export const DATE_FORMAT_DEFAULT = 'YYYY-MM-DD';
export const DATE_FORMAT_INPUT = 'DD/MM/YYYY';
export const DATE_FORMAT_DISPLAY = 'DD MMM YYYY';
export const DATE_FORMAT_DROPDOWN = 'D-M-YYYY';
export const DATE_FORMAT_SHORT = 'D MMM YY';
export const DATE_FORMAT_LONG = 'Mo MMM YYYY';
export const TIME_FORMAT_MILITARY = 'HH:mm';
export const DATE_FORMAT_PART_STAY_GUEST = 'D MMM YYYY';
